/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syllables`)
};

const es_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sílabas`)
};

const de_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silben`)
};

const nl_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettergrepen`)
};

const fr_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syllabes`)
};

const it_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sillabe`)
};

const pt_br2_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sílabas`)
};

const pt_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sílabas`)
};

const ja_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節数`)
};

const zh_ra_metric_syllables = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_metric_syllables = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_metric_syllables(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_metric_syllables", locale)
	if (locale === "en") return en_ra_metric_syllables(inputs)
	if (locale === "es") return es_ra_metric_syllables(inputs)
	if (locale === "de") return de_ra_metric_syllables(inputs)
	if (locale === "nl") return nl_ra_metric_syllables(inputs)
	if (locale === "fr") return fr_ra_metric_syllables(inputs)
	if (locale === "it") return it_ra_metric_syllables(inputs)
	if (locale === "pt-BR") return pt_br2_ra_metric_syllables(inputs)
	if (locale === "pt") return pt_ra_metric_syllables(inputs)
	if (locale === "ja") return ja_ra_metric_syllables(inputs)
	return zh_ra_metric_syllables(inputs)
};